import axios from 'axios'
const request = axios.create({ baseURL: '/api', timeout: 15000 })
export const getCategories = () => request.get('/site/categories')
export const getCategoryDetail = (slug) => request.get(`/site/categories/${slug}`)
export const getArticles = (params) => request.get('/site/articles', { params })
export const getArticleDetail = (slug) => request.get(`/site/articles/${slug}`)
export const getSiteConfig = () => request.get('/site/config')
export const getHistory = () => request.get('/site/history')
export const getSiteContent = (year) => request.get('/site/content', { params: year ? { year } : {} })
export const getSubItems = (key, year) => request.get(`/site/sub-items/${key}`, { params: year ? { year } : {} })
// 网站自身登录/注册（合一，账号不存在自动注册）与留言提交
export const siteLogin = (data) => request.post('/site/auth/login', data)
export const submitMessage = (data) => request.post('/site/messages', data)
export default request
